import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RegistrationComplete = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="register-success" style={{ maxWidth: '480px', margin: '40px auto', textAlign: 'center' }}>
      <div style={{ marginBottom: '16px' }}>
        <img src="/assets/sortafriends.png" alt="SortaFriends Logo" className="logo-image" />
      </div>
      <h2>Registration Complete</h2>
      <p>You've been signed up successfully.</p>
      <p style={{ marginTop: '10px', color: '#666' }}>
        Please check your email for a confirmation message. You'll need to verify your email address to access all features.
      </p>
      <p style={{ marginTop: '10px' }}>Redirecting to your dashboard in 5 seconds…</p>
      <div style={{ marginTop: '16px' }}>
        <a href="/dashboard" className="login-button">Go to Dashboard now</a>
      </div>
    </div>
  );
};

export default RegistrationComplete;


